import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BarGraph from "../../components/graphs/BarGraph";
import dataService from "../../networks/api/service/dataService";
import { Input, message, Switch } from "antd";
import CustomTable from "../TableComponent/CustomTable";

function BhoothGraphDetails() {
  const [booth, setbooth] = useState([]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [boothId, setboothId] = useState("");
  const [skip, setskip] = useState(0);
  const [limit, setlimit] = useState(10);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { panchayatName } = location.state || {};
  const bottomRef = useRef(null); // Ref to scroll to the bottom of the section

  const handleTableChange = (pagination) => {
    const current = pagination.current; // Current page
    const pageSize = pagination.pageSize; // Page size
    const skip = (current - 1) * pageSize; // Calculate skip
    const limit = pageSize; // Limit is the same as page size

    setPagination(pagination);
    setskip(skip);
    setlimit(limit);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    const filtered = data?.filter(
      (item) =>
        item?.firstName?.toLowerCase()?.includes(value) ||
        item?.epicNo?.toLowerCase()?.includes(value)
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      align: "center",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      align: "center",
    },
    {
      title: "Booth Number",
      dataIndex: "boothNumber",
      key: "boothNumber",
      width: 150,
      align: "center",
    },
    {
      title: "Section Number",
      dataIndex: "sectionNumber",
      key: "sectionNumber",
      width: 150,
      align: "center",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      width: 100,
      align: "center",
    },
    {
      title: "Relation Type",
      dataIndex: "relationType",
      key: "relationType",
      width: 100,
      align: "center",
    },
    {
      title: "Relation Name",
      render: (text, voter) => (
        <span>
          {voter.relationFirstName} {voter.relationLastName}
        </span>
      ),
      key: "relationName",
      align: "center",
    },
    {
      title: "EPIC No",
      dataIndex: "epicNo",
      key: "epicNo",
      align: "center",
    },
    {
      title: "Stay Outside",
      render: (text, voter) => {
        return <span>{voter.stayOutSide ? "Yes" : "No"}</span>;
      },
      key: "stayOutSide",
      width: 110,
      align: "center",
    },
    {
      title: "Relation With Sangha Pariwar",
      render: (text, voter) => {
        return <span>{voter.relationWithSanghaPariwar ? "Yes" : "No"}</span>;
      },
      key: "relationWithSanghaPariwar",
      width: 140,
      align: "center",
    },
    {
      title: "Influencer",
      key: "influencer",
      align: "center",

      render: (text, voter) => {
        return <span>{voter.influencer ? "Yes" : "No"}</span>;
      },
    },
    {
      title: "Head Of Family",
      key: "headOfFamily",
      align: "center",

      render: (text, voter) => {
        return <span>{voter.headOfFamily ? "Yes" : "No"}</span>;
      },
    },
  ];

  const handleBarClick = (data) => {
    setboothId(data._id);

    getVotersList(data._id);
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const getVotersList = async (bId) => {
    const data = { _id: bId };

    try {
      const res = await dataService.GetVoters(data, bId, skip, limit, "booth");
      if (res.code === 200) {
        setData(res?.data);
        setFilteredData(res?.data);

        setPagination((prev) => ({
          ...prev,
          total: res?.totalVoters,
        }));
        message.success(res.message);
      }
    } catch (e) {}
  };
  useEffect(() => {
    getVotersList(boothId);
  }, [skip, limit]);

  const getBoothFromPan = async () => {
    const data = { panchayat: id };
    try {
      const res = await dataService.GetBooth(data);
      if (res.code === 200) {
        setbooth(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getBoothFromPan();
  }, [id]);
  return (
    <div>
      <div>
        <BarGraph
          data={booth}
          xKey="boothName"
          title={`Details for Panchayat : ${panchayatName}`}
          bars={[
            {
              key: "totalPopulation",
              color: "#8884d8",
              name: "Total Population",
            },
            { key: "totalMaleVoter", color: "#82ca9d", name: "Male Voters" },
            {
              key: "totalFemaleVoter",
              color: "#ffc658",
              name: "Female Voters",
            },
          ]}
          onBarClick={handleBarClick}
        />
      </div>
      {data.length > 0 && (
        <>
          <Input.Search
            placeholder="Search by Voter Name"
            onChange={handleSearch}
            style={{ width: "100%", maxWidth: 200 }} // Full width on small screens
          />
          <div ref={bottomRef}>
            <CustomTable
              dataSource={filteredData}
              columns={columns}
              rowKey={(record) => record._id}
              // loading={loading}
              bordered
              onChange={handleTableChange}
              customPagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: pagination.total,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20"],
              }}
              size="middle"
              style={{
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                borderRadius: "8px",
                backgroundColor: "#fff",
                width: "100%",
                overflowX: "auto",
              }}
              scroll={{ x: 800 }}
              rowClassName={(record) =>
                record.headOfFamily ? "head-of-family-row" : ""
              } // Conditionally apply class
            />
          </div>
        </>
      )}
    </div>
  );
}

export default BhoothGraphDetails;
